import script from "./BaseIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseIcon.vue?vue&type=script&setup=true&lang=js"

import "./BaseIcon.vue?vue&type=style&index=0&id=26d146cd&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d146cd"]])

export default __exports__